module.exports = __webpack_public_path__ + "static/media/tarjeta-hormigas.3ace1f4d.png";